import { MdOutlineQuestionAnswer } from "react-icons/md";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999] px-3">
      {/* Overlay with Blur */}
      <div
        className="fixed inset-0 bg-black/30 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      >
      </div>

      {/* Modal Content */}
      <div className="bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.2)] w-full max-w-[420px] overflow-hidden border-[1.5px] border-[#1e3a73] flex flex-col items-center pt-8 pb-6 px-6 z-10 transform transition-all animate-in fade-in zoom-in duration-300">

        {/* Icon Circle */}
        <div className="bg-[#1e3a73] rounded-full flex items-center justify-center w-[75px] h-[75px] mb-2">
          <MdOutlineQuestionAnswer className="text-white text-4xl" />
        </div>

        {/* Text Content */}
        <div className="text-center w-full">
          <h2 className="text-[#1a3673] text-[22px] font-bold mb-3 tracking-tight">
            {title || "Confirm Action"}
          </h2>
          <p className="text-[#6b7280] text-[15px] mb-6 leading-relaxed font-medium">
            {message || "Are you sure you want to proceed?"}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex w-full gap-4">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-lg border-[1.5px] border-[#1e3a73] text-[#1e3a73] font-bold text-[16px] hover:bg-blue-50 transition-all duration-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-lg bg-[#10b981] text-white font-bold text-[16px] hover:bg-[#0da371] transition-all duration-200 shadow-sm"
          >
            Yes, Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
